export default class StoricoInterventoEntita{
    DataGestione;
    Eseguito;
    CodiceEsito;
    DescrizioneEsito;
    CodiceAttivita;
    DescrizioneAttivita;
    Riepilogo;
    NoteIntervento;
    Note;
    TipoIntervento;
    SysChiaveglobale;

    constructor(){}
}